import {
  DashboardWorkbook,
  TableauBaseUrlProps,
  WorkbooksByCategory,
  WorkbookUrl,
} from '../models';

export const buildTableauUrl = (
  { baseUrl, siteContentUrl }: TableauBaseUrlProps,
  ticket: string,
  { contentUrl, defaultViewUrlName }: DashboardWorkbook,
  filters?: URLSearchParams
): string => {
  const queryString = filters ? `?${filters.toString()}` : '';
  return `${baseUrl}/${ticket}/t/${siteContentUrl}/views/${contentUrl}/${defaultViewUrlName}${queryString}`;
};

export const getWorkbookUrlByContentUrlAttr = (
  contentUrl: string,
  workbooksByCategory: WorkbooksByCategory
): WorkbookUrl | null => {
  for (const [category, workbooks] of Object.entries(workbooksByCategory)) {
    const [workbookName, queryString] = contentUrl.split('?');
    const workbook = workbooks.find((wb) => wb.contentUrl === workbookName);

    if (workbook) {
      return {
        category: category,
        workbook: workbook.name,
        filters: new URLSearchParams(queryString),
      };
    }
  }
  return null;
};
